export default __webpack_public_path__ + "static/media/trackMyTreeLogo.956d5d30.jpg";